
import bootstrap from '../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import { createPopper } from '@popperjs/core';
import GLightbox from 'glightbox';
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js"
import Swiper, {Navigation, Pagination, EffectCards, EffectCreative, EffectFade, EffectFlip} from 'swiper';
Swiper.use([Navigation, EffectCards,EffectCreative,EffectFade,EffectFlip]);
import LazyLoad from "vanilla-lazyload";
import IMask from 'imask';
import './scss/app.scss';
import { WOW } from 'wowjs';
new WOW().init();
let MagicGrid = require("magic-grid");
var lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazyload'
    // Your custom settings go here
});
const lightbox = GLightbox();
document.addEventListener("DOMContentLoaded", function(event) {
    reinit(document);
});
var canvlist = {};

var myMap = false;
var canvactive = 0;
const toastLiveExample = document.getElementById('liveToast');
const toast = new bootstrap.Toast(toastLiveExample);
var styles = {
    default: null,
    silver: [],


    hiding: [
        {
            "featureType": "all",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "saturation": 36
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 40
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.text.stroke",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "all",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "administrative",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                },
                {
                    "weight": 1.2
                }
            ]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 20
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 21
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.fill",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        },
        {
            "featureType": "road.highway",
            "elementType": "geometry.stroke",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 29
                },
                {
                    "weight": 0.2
                }
            ]
        },
        {
            "featureType": "road.arterial",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 18
                }
            ]
        },
        {
            "featureType": "road.local",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 16
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 19
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [
                {
                    "color": "#000000"
                },
                {
                    "lightness": 17
                }
            ]
        }
    ]
};
var map;
var sldrs = {};
function reinit(obj) {
    if (obj) {
        ActivateLinks(obj);
    }
}
function ActivateLinks(obj) {
    if (document.querySelector('.lead-form')) {
        var forms = document.querySelectorAll('.lead-form');
        for (var i = 0; i < forms.length; i++) {
            forms[i].addEventListener('submit',sendForm,false);
        }

    }
    if (document.querySelector('.full-swiper')) {
        var interleaveOffset = 1;

        var swiperOptions = {
            loop: true,
            speed: 1000,
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: true,
            keyboardControl: true,

        };

        const swiper = new Swiper(".full-swiper", swiperOptions);
    }
    if (document.querySelector('.navigate-swiper')) {
        var interleaveOffset = 1;

        var swiperOptions = {
            loop: true,
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: false,
            keyboardControl: false,
            allowTouchMove: false

        };
        var slds = document.querySelectorAll('.navigate-swiper');
        for (var i = 0; i < slds.length; i++) {
            sldrs[slds[i].dataset.id] = new Swiper("#"+slds[i].id, swiperOptions);
        }
        var btns = document.querySelectorAll('.navigate-swiper-btn');
        for (var i = 0; i < btns.length; i++) {
            btns[i].addEventListener('click',changeSlide,false);
        }

    }
    if (document.querySelector('.command-swiper')) {
        var interleaveOffset = 1;

        var swiperOptions = {
            loop: true,
            speed: 1000,
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: true,
            keyboardControl: true,
            navigation: {
                nextEl: ".swiper-command-button-next",
                prevEl: ".swiper-command-button-prev"
            },
            on: {
                progress: function(swip, progress) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        var slideProgress = swip.slides[i].progress;
                        var innerOffset = swip.width * interleaveOffset;
                        var innerTranslate = slideProgress * innerOffset;
                        swip.slides[i].querySelector(".slide-inner-body").style.transform =
                            "translate3d(" + innerTranslate + "px, 0, 0)";
                    }
                },
                beforeTransitionStart: function (swip,speed,internal) {
                    for (var i = 0; i <  swip.slides.length; i++) {
                        swip.slides[i].style.transition = "";
                    }
                },
                setTransition: function(swip,speed) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        swip.slides[i].style.transition = speed + "ms";
                        swip.slides[i].querySelector(".slide-inner-body").style.transition =
                            speed + "ms";
                    }
                }
            }
        };
        // var interleaveOffset = 1;
        //
        // var swiperOptions = {
        //     loop: true,
        //     speed: 1000,
        //     // effect: 'fade',
        //     grabCursor: true,
        //     watchSlidesProgress: true,
        //     mousewheelControl: true,
        //     keyboardControl: true,
        //     modules: [Navigation],
        //     navigation: {
        //         nextEl: ".swiper-button-next",
        //         prevEl: ".swiper-button-prev"
        //     },
        // };

        const swiper = new Swiper(".command-swiper", swiperOptions);
    }
    if (document.querySelector('.swiper-rows')) {
        var interleaveOffset = 1;

        var swiperOptions = {
            loop: true,
            speed: 1000,
            // effect: 'fade',
            slidesPerView: 4,
            // virtualTranslate: true,
            slidesPerGroup: 4,
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: true,
            keyboardControl: true,
            modules: [Navigation],
            breakpoints: {
                // when window width is >= 320px
                120: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                // when window width is >= 480px
                576: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                // when window width is >= 640px
                993: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                }
            },
            on: {
                beforeSlideChangeStart: function (swip,speed,internal) {
                        for (var i = 0; i < swip.slides.length; i++) {
                            swip.slides[i].classList.add('ready-slide');
                        }

                },
                beforeTransitionStart: function (swip,speed,internal) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        swip.slides[i].classList.add('opacity-0');
                        swip.slides[i].classList.add('ready-slide');
                        swip.slides[i].querySelector(".white-icon").classList.add('py-5');
                    }
                },
                transitionEnd: function (swip) {
                    for (var i = 0; i < swip.slides.length; i++) {
                        swip.slides[i].classList.remove('opacity-0');
                        swip.slides[i].querySelector(".white-icon").classList.remove('py-5');
                    }
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },

        };

        const swiper = new Swiper(".swiper-rows", swiperOptions);
    }
    if (document.querySelector('[data-bs-toggle="tooltip"]')) {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    }
    if (document.querySelector('.set-currency-link')) {
        var currlinks = document.querySelectorAll('.set-currency-link');
        for (var i = 0; i < currlinks.length; i++) {
            currlinks[i].addEventListener('click',setCurrency,false);
        }
    }
    if (document.querySelector('.drop-max')) {
        var withoutCanvlinks = document.querySelectorAll('.header .toggle-canv');
        for (var i = 0; i < withoutCanvlinks.length; i++) {
            withoutCanvlinks[i].addEventListener('mouseenter',hideCanvas,false);
        }
        var withoutCanvBodys = document.querySelectorAll('.drop-canvas');
        for (var i = 0; i < withoutCanvBodys.length; i++) {
            withoutCanvBodys[i].addEventListener('mouseleave',hideCanvasBody,false);
        }


    }
    if (document.querySelector('.select-country')) {
        var countrylinks = document.querySelectorAll('.select-country');
        for (var i = 0; i < countrylinks.length; i++) {
            countrylinks[i].addEventListener('click',selectCountry,false);
        }
    }
    if (document.querySelector('input[type="tel"]')) {
        var telInputs = document.querySelectorAll('input[type="tel"]');

        for (var i = 0; i < telInputs.length; i++) {
            IMask(
                telInputs[i],
                {
                    mask: '+{7}(000)000-00-00'
                }
            )
        }
    }
    if (document.getElementById('map')) {
        initialize();
    }
    if (document.querySelector('.main-slide-nav')) {
        var mainslidenavs = document.querySelectorAll('.main-slide-nav');
        for (var i = 0; i < mainslidenavs.length; i++) {
            mainslidenavs[i].addEventListener('click',changeMainSlide,false);
        }
    }
}
function changeSlide(e){
    var point = parseInt(e.currentTarget.dataset.key);
    var btns = e.currentTarget.parentNode.querySelectorAll('.navigate-swiper-btn');
    for (var i = 0; i < btns.length; i++) {
        if (parseInt(btns[i].dataset.key) == point) {
            btns[i].classList.add('active');
        } else {
            btns[i].classList.remove('active');
        }
    }
    sldrs[e.currentTarget.dataset.id].slideTo(point);
}
function changeMainSlide(e) {
    if (!e.currentTarget.classList.contains('active')) {
        var parent = document.getElementById(e.currentTarget.dataset.id);
        var step = e.currentTarget.dataset.step;
        var navs = parent.querySelectorAll('.main-slide-nav');
        var slides = parent.querySelectorAll('.main-slide');
        for (var i = 0; i < navs.length; i++) {
            if (navs[i].dataset.step === step) {
                navs[i].classList.add('active');
                slides[i].classList.add('active');
            } else {

                navs[i].classList.remove('active');
                slides[i].classList.remove('active');
            }
        }
    }

}
function selectCountry(e) {
    e.preventDefault();
    var dial = e.currentTarget.dataset.dial;
    var country = e.currentTarget.dataset.country;
    var btn = e.currentTarget.parentNode.parentNode.parentNode.querySelector('.dropdown-toggle span');
    btn.classList.remove('flag-icon-'+btn.dataset.country);
    btn.classList.add('flag-icon-'+country);
    e.currentTarget.parentNode.parentNode.parentNode.parentNode.querySelector('input').value = '+'+dial;
}
function regPhone(e) {
    let regex = /[^\d\+]/g;
    let regex2 = /\d\+/g;
    e.target.value = e.target.value.replace(regex, '').replace(regex2,'');
}
function sendForm(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var data =  new FormData(form);
    var request = new XMLHttpRequest();
    var link = '/lead-form/';
    request.open("POST", link, true);
    // request.setRequestHeader("Content-Type", "application/json");
    // request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    request.send(data);
    request.onreadystatechange = function () {
        if (request.readyState === 4 && request.status === 200) {
            var data = JSON.parse(request.response);
            if (data.error) {
                var inputs = form.querySelectorAll('input,select,textarea');
                for (var i = 0; i < inputs.length; i++) {
                    var name = inputs[i].getAttribute("name");
                    if (data.errors.hasOwnProperty(name)) {
                        inputs[i].classList.add('is-invalid');
                    } else {
                        inputs[i].classList.remove('is-invalid');
                    }
                }

            } else {
                var inputs = form.querySelectorAll('input,select,textarea');
                for (var i = 0; i < inputs.length; i++) {
                        inputs[i].classList.remove('is-invalid');
                        var type = inputs[i].getAttribute('type');
                        if (type ==='text' || type ==='tel' || type ==='email' || inputs[i].tagName == 'TEXTAREA') {
                            inputs[i].value = '';
                        }
                }
                bootstrap.Modal.getOrCreateInstance(document.getElementById('findpersonal')).hide();
                bootstrap.Modal.getOrCreateInstance(document.getElementById('findvacancy')).hide();
                bootstrap.Modal.getOrCreateInstance(document.getElementById('modallead')).hide();
                bootstrap.Modal.getOrCreateInstance(document.getElementById('modalsuccess')).show();


            }
        };
    };
}

function hideCanvas(e) {
    if (e.currentTarget.classList.contains('drop-max')) {
        var id = e.currentTarget.dataset.id;
        if (canvactive !== 0) {
            bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('submenu-'+canvactive)).hide();
        }
        bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('submenu-'+id)).show();
        document.querySelector('.header').classList.add('scroll-header');
        canvactive = parseInt(id);
    } else {
        if (canvactive !== 0) {
            bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('submenu-'+canvactive)).hide();
            canvactive = 0;
        }
    }
}
function hideCanvasBody(e) {
        if (canvactive !== 0) {
            bootstrap.Offcanvas.getOrCreateInstance(document.getElementById('submenu-'+canvactive)).hide();
            canvactive = 0;
        }
}
let lastKnownScrollPosition = 30;
let ticking = false;
function doSomething(scrollPos) {
    // Do something with the scroll position
}
document.addEventListener("scroll", (event) => {
    var positionScroll = window.scrollY;
    if (positionScroll > lastKnownScrollPosition && positionScroll > 50) {
        hideHeader();
    } else {
        showHeader();
    }
    initHeader();
    lastKnownScrollPosition = window.scrollY;
});
function initHeader(){
    if (window.scrollY > 10) {
        if (!document.querySelector('.header').classList.contains('scrolled-header')) {
            document.querySelector('.header').classList.add('scrolled-header');
        }
        document.getElementById('scroll-top').classList.remove('d-none');
        document.getElementById('scroll-top').classList.add('d-block');
    } else {
        document.querySelector('.header').classList.remove('scrolled-header');
        document.getElementById('scroll-top').classList.add('d-none');
        document.getElementById('scroll-top').classList.remove('d-block');
    }
}
function hideHeader() {
    document.querySelector('.header').classList.add('scrolled-header');

}
function showHeader() {
    document.querySelector('.header').classList.remove('scrolled-header');

}




function changeOffice(e) {
    var lat = parseFloat(e.currentTarget.dataset.lat);
    var lon = parseFloat(e.currentTarget.dataset.lon);
    myMap.setCenter([lon, lat]);
    myMap.setZoom(14);
    var offices = document.querySelectorAll('.office-div');
    for (var i = 0; i < offices.length; i++) {

        var lat2 = parseFloat(offices[i].dataset.lat);
        var lon2 = parseFloat(offices[i].dataset.lon);
        if (lon2 === lon && lat2 === lat) {
            offices[i].classList.add('bg-primary');
            offices[i].classList.add('text-white');
        } else {
            offices[i].classList.remove('bg-primary');
            offices[i].classList.remove('text-white');
        }
    }

}
function changeOfficePoint(e) {
   var iden = e.get('target').properties.get("iden");
    var offices = document.querySelectorAll('.office-div');
    for (var i = 0; i < offices.length; i++) {
        if (i == iden) {
            offices[i].parentNode.scrollTop = offices[i].offsetTop;
            offices[i].classList.add('bg-primary');
            offices[i].classList.add('text-white');
        } else {
            offices[i].classList.remove('bg-primary');
            offices[i].classList.remove('text-white');
        }
    }
}
function setDefaultZoom() {
    myMap.setCenter([55.751574, 37.573856]);
    myMap.setZoom(3);
    var offices = document.querySelectorAll('.office-div');
    for (var i = 0; i < offices.length; i++) {
        offices[i].classList.remove('bg-primary');
        offices[i].classList.remove('text-white');
    }
}
function initialize() {
    ymaps.ready(function () {
        myMap = new ymaps.Map('map', {
                center: [55.751574, 37.573856],
                zoom: 3
            }, {
                searchControlProvider: 'yandex#search'
            });
        myMap.controls.remove('searchControl');
        myMap.controls.remove('typeSelector');
        myMap.controls.remove('trafficControl');
        var myButton =
            new ymaps.control.Button(
                '<b>назад</b>'
            );
        myButton.events
            .add(
                'click',
                setDefaultZoom
            );

        myMap.controls.add(myButton, {
            float: "left"
        });
        var MyIconContentLayout = ymaps.templateLayoutFactory.createClass(
            '<div style="color: #FFFFFF; font-weight: bold;">$[properties.iconContent]</div>'
        );
        var offices = document.querySelectorAll('.office-div');
        for (var i = 0; i < offices.length; i++) {
            offices[i].addEventListener('click',changeOffice,false);
            var address = 'г. ' + offices[i].querySelector('.office-div-city').innerHTML + ' ' +  offices[i].querySelector('.office-div-address').innerHTML
            var lat = parseFloat(offices[i].dataset.lat);
            var lon = parseFloat(offices[i].dataset.lon);
            var myPlacemarkWithContent = new ymaps.Placemark([lon,lat], {
                balloonContent: address,
            }, {
                // Опции.
                // Необходимо указать данный тип макета.
                iconLayout: 'default#imageWithContent',
                // Своё изображение иконки метки.
                iconImageHref: '/images/locationvp.svg',
                // Размеры метки.
                iconImageSize: [32, 32],
                // Смещение левого верхнего угла иконки относительно
                // её "ножки" (точки привязки).
                iconImageOffset: [-24, -24],
                // Смещение слоя с содержимым относительно слоя с картинкой.
                iconContentOffset: [15, 15],
                // Макет содержимого.
                iconContentLayout: MyIconContentLayout
            });
            myPlacemarkWithContent.properties.set("iden", i);
            myPlacemarkWithContent.events.add('click', changeOfficePoint);
            myMap.geoObjects
                .add(myPlacemarkWithContent);
        }
    });
}

function getPointsArr() {
    var points = document.querySelectorAll('.google-maps-div-office');
    var arr = [];
    for (var i = 0; i < points.length; i++) {
        var item = {
            'title' : points[i].dataset.title,
            'content' : points[i].dataset.content,
            'lat' : parseFloat(points[i].dataset.lat),
            'lang' : parseFloat(points[i].dataset.lang),
        };
        arr.push(item);
    }
    return arr;
}

function setMarkers(map,locations){
    for (var i = 0; i < locations.length; i++)
    {

        var loan = locations[i].title;
        var lat = locations[i].lat;
        var long = locations[i].lang;
        var content =  locations[i].content;
        var latlngset = new google.maps.LatLng(lat, long);

        var marker = new google.maps.Marker({
            map: map,
            title: loan ,
            position: latlngset,
            icon: {
                url: "/images/location.svg",
                scaledSize: new google.maps.Size(40, 60)
            },
        });
        map.setCenter(marker.getPosition())

        var content = '<div class="content-map"><div class="col-12"><h4 class="fs-5 mb-3">' + loan +  '</h4>' + content + '</div></div>'


        var infowindow = new google.maps.InfoWindow()

        google.maps.event.addListener(marker,'click', (function(marker,content,infowindow){
            return function() {
                infowindow.setContent(content);
                infowindow.open(map,marker);
            };
        })(marker,content,infowindow));

    }
}


